import {emitActionEvent} from '../../services/analytics'

export const analyticsMiddleware = (store:any) => (next:any) => (action:any) => {
    emitActionEvent(action?.type, {})

    return next(action)
}
